import React, { useContext } from "react";

//** MUI Components */
import Paper from "@mui/material/Paper";
import Button from "@mui/material/Button";

//* NDBX
import {
  OneColumnStack,
  Section,
  // RHFTextField,
} from "@arp/react-ndbx";

import RHFTextField from "../../../components/coding/rhfTextField/RHFTextField";

//** Context  */
import { PaymentContext } from "../../../context/BraintreeContext";

const fullyMaskCreditCardNumber = (originalValue) => {
  const originalNumber = originalValue;

  // Convert the number to a string
  const numberString = originalNumber.toString();

  // Get the last four digits
  const lastFourDigits = numberString.slice(-4);

  // Replace all but the last four digits with '*'
  const maskedString = "*".repeat(numberString.length - 4) + lastFourDigits;

  return maskedString;
};

//** ----------------------------------------------------------------
//** Readonly display of Credit Card details **/
const CreditCardDetails = ({ resetCardValues = false, openModalOnRecapture }) => {
  const paymentContext = useContext(PaymentContext);
  const { setCapturedData, secureCoCapturedData } = paymentContext;

  const { maskedCardNumber, cardHolderName, cardType, expiry } = {
    ...secureCoCapturedData,
  };

  const recaptureAndOpen = (e) => {
    e.preventDefault();
    setCapturedData({});
    openModalOnRecapture();
  };

  return (
    <Paper
      elevation={0}
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        alignItems: "flex-start",
        backgroundColor: "#F1F9FA",
        pt: 4,
        pb: 4,
        px: 1,
      }}
    >
      <OneColumnStack name="credit-card-number-readonly" maxWidth={"100%"}>
        <Section>
          <RHFTextField
            className="subvariant-text-input"
            variant="standard"
            label="Name on card"
            controlIdentifier="name-on-credit-card"
            name="name-on-card-input"
            sx={{ width: "100%" }}
            fullWidth
            defaultValue={resetCardValues === true ? "" : cardHolderName}
            readOnly={true}
          />
        </Section>
      </OneColumnStack>
      <OneColumnStack name="credit-card-number-readonly" maxWidth={"100%"}>
        <Section>
          <RHFTextField
            className="subvariant-text-input"
            variant="standard"
            label="Card Number"
            controlIdentifier="credit-card-number"
            name="credit-card-number"
            sx={{ width: "100%" }}
            fullWidth
            defaultValue={resetCardValues === true ? "" : maskedCardNumber}
            readOnly={true}
          />
        </Section>
      </OneColumnStack>
      <OneColumnStack name="credit-card-type-readonly" maxWidth={"100%"}>
        <Section>
          <RHFTextField
            className="subvariant-text-input"
            variant="standard"
            label="Card Type"
            controlIdentifier="credit-card-type"
            name="credit-card-type"
            sx={{ width: "100%" }}
            fullWidth
            defaultValue={resetCardValues === true ? "" : cardType}
            readOnly={true}
          />
        </Section>
      </OneColumnStack>
      <OneColumnStack name="credit-card-expiry-readonly" maxWidth={"100%"}>
        <Section>
          <RHFTextField
            className="subvariant-text-input"
            variant="standard"
            label="Expiry date"
            controlIdentifier="credit-card-expiry"
            name="credit-card-expiry"
            sx={{ width: "100%" }}
            fullWidth
            defaultValue={resetCardValues === true ? "" : expiry}
            readOnly={true}
          />
        </Section>
      </OneColumnStack>
      <Section mt={2} sx={{ maxWidth: { xs: "350px" } }}>
        <Button
          variant="contained"
          color="primary"
          onClick={(e) => {
            recaptureAndOpen(e);
          }}
          // disabled={checkIsLoading && paymentTokenIsLoading}
        >
          Recapture Card Details
        </Button>
      </Section>
    </Paper>
  );
};

export default CreditCardDetails;
